import { Toast } from '@react/react-spectrum/Toast';
import React from 'react';
import styled from 'styled-components';

import { useMediaQuery } from '@exchange-frontends/custom-hooks';

const CustomToast = styled(Toast)`
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1;
`;

const pluginAcquiredMobileText = 'Plugin acquired. Install using Creative Cloud desktop app.';
const pluginAcquiredText = 'Plugin acquired, install using Creative Cloud desktop app version 5.3 or later';

const InstallationToast = ({ close, onInstallClick }) => {
  const isMobileSized = useMediaQuery('(max-width: 500px)');

  return isMobileSized ? (
    <CustomToast variant="info" onClose={close} closable>
      {pluginAcquiredMobileText}
    </CustomToast>
  ) : (
    <CustomToast variant="success" onClose={close} closable actionLabel="Install" onAction={onInstallClick}>
      {pluginAcquiredText}
    </CustomToast>
  );
};

export default InstallationToast;
